import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getInquiriesList = createAsyncThunk(
  'inquiry/getInquiriesList',
  async ({ skip, limit, status, search }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(status ? { status } : {}),
          ...(search ? { search } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/contact-us-forms`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getInquiryById = createAsyncThunk(
  'inquiry/getInquiryById',
  async ({ id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/contact-us-forms/${id}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const editInquiryInfo = createAsyncThunk(
  'inquiry/editInquiryInfo',
  async (inquiryData, { rejectWithValue }) => {
    try {  
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      
      const body = JSON.stringify(inquiryData);

      const response = await axios.put(
        `${PUBLIC_BASE_URL}/contact-us-forms/update-contact-us-form-info`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);
